import { render, staticRenderFns } from "./downTime.vue?vue&type=template&id=2fce3e8a&scoped=true"
import script from "./downTime.vue?vue&type=script&lang=ts"
export * from "./downTime.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fce3e8a",
  null
  
)

export default component.exports